import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Agenda\UpdateEventAgendaController::__invoke
* @see app/Http/Controllers/Agenda/UpdateEventAgendaController.php
* @route '/api/agenda/update-event/{event}'
*/
const UpdateEventAgendaController = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateEventAgendaController.url(args, options),
    method: 'put',
})

UpdateEventAgendaController.definition = {
    methods: ["put"],
    url: '/api/agenda/update-event/{event}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Agenda\UpdateEventAgendaController::__invoke
* @see app/Http/Controllers/Agenda/UpdateEventAgendaController.php
* @route '/api/agenda/update-event/{event}'
*/
UpdateEventAgendaController.url = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return UpdateEventAgendaController.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Agenda\UpdateEventAgendaController::__invoke
* @see app/Http/Controllers/Agenda/UpdateEventAgendaController.php
* @route '/api/agenda/update-event/{event}'
*/
UpdateEventAgendaController.put = (args: { event: string | number | { id: string | number } } | [event: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateEventAgendaController.url(args, options),
    method: 'put',
})

export default UpdateEventAgendaController